import * as React from 'react'
import { FiRefreshCw } from 'react-icons/fi'

export default function() {
  return (
    <FiRefreshCw
      style={{ marginRight: '5px', minHeight: '16px', minWidth: '16px' }}
    />
  )
}
